const INITIAL_STATE = {
  data: {},
  errors: {},
    
}
const verifyRegisterUser = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'VERIFY_USER_SUCCESSFULLY':
    return { ...state, ...INITIAL_STATE, 'data': action.data }
  case 'VERIFY_USER_FAILED':
    return { ...state, ...INITIAL_STATE, 'errors': action.data }
  default:
    return { ...state }
  }
};
    
export default verifyRegisterUser;